import { isUserLoggedIn, logIn } from '../utils/auth';
import QuizImage from '../assets/quiz-finished.png';
import Button from './Button';

type Props = {
  children: React.ReactNode;
  text?: string;
  className?: string;
  additionalContent?: React.ReactNode;
};

const AuthGuard = ({
  children,
  text = 'Prijavi se kako bi video svoj profil',
  className,
  additionalContent
}: Props) => {
  const isLoggedIn = isUserLoggedIn();

  const handleLogin = () => {
    logIn();
  };

  return (
    <div className={className}>
      {!isLoggedIn && (
        <>
          <div className="text-center mt-5">
            <img src={QuizImage} alt="Quiz finished" className="mx-auto" />
          </div>

          <div className="text-center mt-4">
            {text}
            <Button className="mt-4 ms-0 mx-auto" onClick={handleLogin}>
              Prijavi se
            </Button>
            {additionalContent}
          </div>
        </>
      )}

      {isLoggedIn && <>{children}</>}
    </div>
  );
};

export default AuthGuard;
